import script from "./EventSinglePublic.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSinglePublic.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/clubstyle.css?vue&type=style&index=0&lang=css&external"
import "./EventSinglePublic.vue?vue&type=style&index=1&id=f6a7f7fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6a7f7fe"]])

export default __exports__